
























import { Vue, Component, Prop } from 'vue-property-decorator';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import eventBus from '@/utils/eventBus';

import {
  ICustomerInactivityStep,
  ICustomerInactivityFormData,
  ECustomerInactivityStepSlug,
  CustomerInactivityEvent
} from '@/models/customer-inactivity';

import InfoInactivity from './Steps/InfoInactivity.vue';
import EditInactivity from './Steps/EditInactivity.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseModalIcon,

    EditInactivity,
    InfoInactivity
  }
})
export default class CustomerInactivityModal extends Vue {
  @Prop() onConfirm!: () => void;
  @Prop() onModalClose!: () => void;
  @Prop({ default: () => ECustomerInactivityStepSlug.EDIT })
  initialStep!: ECustomerInactivityStepSlug;

  ECustomerInactivityStepSlug = ECustomerInactivityStepSlug;

  activeStepSlug: string = this.initialStep;
  loading = false;

  customerInactiveFormData: ICustomerInactivityFormData = {
    slug: '',
    value: undefined
  };

  get stepBySlug(): {
    [k: string]: ICustomerInactivityStep;
  } {
    return {
      [ECustomerInactivityStepSlug.EDIT]: {
        title: 'Set up customer inactivity',
        component: 'EditInactivity'
      },
      [ECustomerInactivityStepSlug.INFO]: {
        title: 'Inactive customers',
        component: 'InfoInactivity'
      }
    };
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  created() {
    this.resizeEventHandler();
  }

  beforeDestroy() {
    Object.assign(document.body.style, {
      overscrollBehavior: 'auto'
    });

    window.removeEventListener('resize', this.resizeEventHandler);
  }

  resizeEventHandler() {
    const vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty(
      '--inactivity-consumers-modal-vh',
      `${vh}px`
    );
  }

  handleTrackEvents() {
    const currentComponent = this.stepBySlug[this.activeStepSlug].component;

    const mapper: Record<string, () => void> = {
      EditInactivity: () => {
        segmentIo.modal('Inactive Consumers Edit');
      },
      InfoInactivity: () => {
        segmentIo.modal('Inactive Consumers Learn More');
      }
    };

    if (!mapper[currentComponent]) return;

    mapper[currentComponent]();
  }

  mounted() {
    this.handleTrackEvents();

    document.onkeydown = this.handleOnkeydown;

    Object.assign(document.body.style, {
      overscrollBehavior: 'none'
    });

    window.addEventListener('popstate', () => {
      this.onClose();
    });
    if (this.$route.query.initialStep) {
      this.activeStepSlug = this.$route.query
        .initialStep as ECustomerInactivityStepSlug;
    }
  }

  handleOnkeydown({ key }: KeyboardEvent) {
    if (key === 'Escape') {
      this.onClose();
    }
  }

  onClose() {
    eventBus.$emit('closeModal');

    if (this.onModalClose) {
      this.onModalClose();
    }
  }

  onClickOutside(event: any) {
    if (event.target.className.includes('modal')) {
      this.onClose();
    }

    return;
  }

  onGoToStep(params: { redirectToStep: ECustomerInactivityStepSlug }) {
    if (this.isMobileDevice) this.scrollToTop();

    this.activeStepSlug = params.redirectToStep;
  }

  scrollToTop() {
    const el = document.querySelector('.customer-inactivity-modal__body');
    if (el) el.scrollTo({ top: 0 });
  }

  handleOnConfirm() {
    this.onClose();
    this.onConfirm();
  }

  handleEvents({ type, params }: CustomerInactivityEvent) {
    const eventMapper: Record<string, () => void> = {
      closeModal: () => this.onClose(),
      goToStep: () => this.onGoToStep(params),
      confirm: () => this.handleOnConfirm()
    };

    if (!eventMapper[type]) return;

    eventMapper[type]();
  }
}
